import React from 'react'

import Divider from 'material-ui/Divider'
import CircularProgress from 'material-ui/CircularProgress'
import { dateDisplayFromString, hourDisplayFromString } from '../helpers'

export const CourseView = props => {
  const { name, credits, description, location, cost, date } = props.record

  return props.record ? (
    <div style={styles.main}>
      <h4>Credite:</h4>
      <span>{credits} credite</span>
      <h4>Cost:</h4>
      <span>{cost} RON</span>
      <h4>Descriere curs:</h4>
      <span>{description}</span>
      <h4>Data curs:</h4>
      <span>{dateDisplayFromString(date)}</span>
      <h4>Ora curs:</h4>
      <span>{hourDisplayFromString(date)}</span>
      <h4>Locatie curs:</h4>
      <span>{location}</span>
      <Divider style={{ marginTop: 30 }} />
    </div>
  ) : (
    <CircularProgress />
  )
}

const styles = {
  main: {},
}



// WEBPACK FOOTER //
// ./src/components/CourseView.js